import React, { useState } from "react";
import FormAccordion from "../../../components/Form/FormAccordion";
import { InputField, SelectField, TextAreaField } from "../../../components/Form/FormComponents";
import { StyledForm } from "../../../components/Form/FormComponents.styled";
import { Button } from "@mui/material";
import ActionSideBar from "./ActionSideBar";
import { DurationOptions } from "../../../Constants";
import { LeaseStructureOptions } from "../data";
import { Navigate, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import { getNairaFormat } from "../../../utils/Utils";
import { toast } from "react-toastify";
import { createAssetLeaseCopy, getProductsObjects } from "../utils";
import { setLoadingState } from "../../../redux/AppSlice";
import Parse from "../../../api/ApiConfig";

const CreateSummary = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { productData, productObj } = useSelector((state) => state.lease);

	const [formData, setFormData] = useState({
		productName: productData?.productName,
		leaseStructure: productData?.leaseStructure,
		amountToLease: productData?.amountToLease,
		// safetyFunds: productData?.safetyFunds,
		waitingPeriod: productData?.waitingPeriod,
		leaseDuration: productData?.leaseDuration,
		interestRate: productData?.interestRate,
		paymentType: productData?.paymentType,
		description: productData?.description,
		keyFeatures: productData?.keyFeatures,
		specifications: productData?.specifications,
		leaseType: productData?.leaseType,
		type: productData?.type,
	});

	const handleInputChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const interestToEarn =
		Number(productObj?.amount?.replaceAll(",", "")) *
		(Number(formData?.interestRate?.replaceAll("%", "")) / 100);

	const User = Parse.Object.extend("_User");
	const user = new User();
	user.id = Parse.User.current()?.id;

	const Product = Parse.Object.extend("Products");
	const product = new Product();
	product.id = productObj?.objectId;

	const productObject = getProductsObjects(productObj);

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (!formData?.leaseStructure) {
			navigate("/lease/create_asset/product_info");
			return;
		}

		dispatch(setLoadingState(true));

		const data = {
			amountToInvest: formData?.amountToLease,
			leaseDuration: formData?.leaseDuration,
			leaseStructure: formData?.leaseStructure,
			leaseType: formData?.leaseType,
			userId: user,
			productId: product,
			status: "inactive",
			interest: formData?.interestRate?.replace("%", ""),
			type: formData?.type,
			productObj: productObject,
			investors: ["Fortcore Admin"],
			paidSlots: 0,
			investorsArray: [
				{
					user: "Fortcore Admin",
					slots: 4,
					amountToInvest: productObj?.amount,
					interestToEarn,
					paid: false,
				},
			],
		};

		try {
			const res = await createAssetLeaseCopy(data);

			const assetId = res?.id;
			toast.success("Asset created successfully, Finance admin will be notified");
			dispatch(setLoadingState(false));
			navigate(`/lease/inactive/${assetId}?filter=quick_lease`);
		} catch (error) {
			console.log(error);
			toast.error(error || "Error creating asset");
			dispatch(setLoadingState(false));
		}

		// API call to create asset lease
		// console.log(res);
		// if (res?.data) {
		// 	let assetId = res.data.objectId;
		// 	toast.success("Asset created successfully, Finance admin will be notified");
		// 	dispatch(setLoadingState(false));
		// 	navigate(`/lease/inactive/${assetId}?filter=quick_lease`);
		// } else {
		// 	toast.error(res?.error || "Error creating asset");
		// 	dispatch(setLoadingState(false));
		// }
	};

	if (!formData?.leaseStructure) {
		return <Navigate to='/lease/create_asset/product_info' />;
	}

	return (
		<StyledForm onSubmit={handleSubmit}>
			<ActionSideBar leaseData={productData} />

			<div className='RightSection'>
				<FormAccordion title='Lease Information' open={true}>
					<div className='grid grid-cols-3 gap-3'>
						{/* <div className='form-group'>
							<label>DATE / TIME</label>
							<InputField name='createdAt' value={getFormattedDate(formData?.createdAt)} />
						</div>

						<div className='form-group'>
							<label>TRN ID</label>
							<InputField name='trnId' value={"---"} />
						</div> */}

						<div className='form-group'>
							<label>ASSET</label>
							<InputField name='productName' value={formData?.productName} />
						</div>

						<div className='form-group'>
							<label>CATEGORY</label>
							<InputField name='productCategory' value={productData?.category} />
						</div>

						<div className='form-group'>
							<label>SUB CATEGORY</label>
							<InputField name='subCategory' value={productData?.subCategory} />
						</div>

						<div className='form-group'>
							<label>BRAND</label>
							<InputField name='brand' value={productData?.brand} />
						</div>

						<div className='form-group'>
							<label>MODEL</label>
							<InputField name='model' value={productData?.model} />
						</div>

						<div className='form-group'>
							<label>COLOR</label>
							<InputField name='color' value={productData?.color} />
						</div>

						<div className='form-group'>
							<label>LEASE TYPE</label>
							<InputField name='leaseType' value={productData?.leaseType} />
						</div>

						<div className='form-group'>
							<label>LEASE STRUCTURE</label>
							<SelectField
								name='leaseStructure'
								handleChange={handleInputChange}
								value={formData?.leaseStructure}
								options={LeaseStructureOptions}
							/>
						</div>

						{/* <div className='form-group'>
							<label>AMOUNT TO INVEST</label>
							<InputField name='amountToLease' value={getNairaFormat(formData?.amountToLease)} />
						</div> */}

						{/* <div className='form-group'>
							<label>SAFETY FUNDS</label>
							<InputField name='safetyFunds' value={getNairaFormat(formData?.safetyFunds)} />
						</div> */}

						{/* <div className='form-group'>
							<label>WAITING PERIOD</label>
							<SelectField
								name='waitingPeriod'
								value={formData?.waitingPeriod}
								options={["Quick", "Normal", "Slow"]}
							/>
						</div> */}

						<div className='form-group'>
							<label>LEASE DURATION</label>
							<SelectField name='leaseDuration' value={formData?.leaseDuration} options={DurationOptions} />
						</div>

						<div className='form-group'>
							<label>INTEREST RATE</label>
							<InputField name='interestRate' value={formData?.interestRate} />
						</div>

						<div className='form-group'>
							<label>INVESTMENT TYPE</label>
							<InputField
								name='investmentType'
								value={formData?.type === "full-investment" ? "Full Investment" : ""}
							/>
						</div>
					</div>
				</FormAccordion>

				<FormAccordion title='Product description'>
					<div className='form-group'>
						<TextAreaField
							name='product_desc'
							value={formData?.description || formData?.productId?.description}
						/>
					</div>
				</FormAccordion>

				<FormAccordion title='Key features'>
					<div className='form-group'>
						<TextAreaField
							name='product_features'
							value={formData?.keyFeatures && formData?.keyFeatures?.replace(/;/g, "<br/>")}
						/>
					</div>
				</FormAccordion>

				<FormAccordion title='Product specifications'>
					<div className='form-group'>
						<TextAreaField
							name='product_specs'
							value={formData?.specifications && formData?.specifications?.replace(/;/g, "<br/>")}
						/>
					</div>
				</FormAccordion>

				<Button variant='contained' color='primary' type='submit' sx={{ mt: 4, mx: 2, px: 5 }}>
					Create Asset
				</Button>
			</div>
		</StyledForm>
	);
};

export default CreateSummary;
